import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import PropTypes from 'prop-types'
import useMobileDetect from 'helpers/mobile-detect'

import { LazyBackgroundImage } from 'components/share/withImages'

import styles from './testimonial-card.module.scss'

export default function Index ({ item, setActiveItem, setModalShow }) {
  const currentDevice = useMobileDetect()
  const [img, setImg] = useState('')
  const bgImg = `url(${img})`

  useEffect(() => {
    if (item.imgFeature) {
      setImg(API_URL + item.imgFeature.url)
    }
  }, [currentDevice, item])

  useEffect(() => {
    LazyBackgroundImage({ src: img, loaded: currentDevice.width > 0 })
  }, [img])

  return (
    <div
      key={`image-${item.id}`}
      className={`col-6 col-md-3 col-lg-2 ${styles['card-item']}`}
    >
      <div className="card-thumbnail">
        {item.imgFeature && <div
          className='card-thumbnail-img lazy-background'
          style={{ backgroundImage: bgImg }}
          alt=''
        />}
      </div>
      <div className={styles['card-item__overlay']}>
        <p className={`h6 ${styles['card-item__text']}`}>
          {item.title}
        </p>
        {
          item.story &&
          <Button
            className={`bg-transparent ${styles['card-item__read-story']}`}
            onClick={() => {
              setModalShow(true)
              setActiveItem(item)
            }}
          >
            Show story
            <img
              className='ms-1'
              width='16px'
              height='16px'
              src='/static/images/testimonials/icon-story.svg'
            />

          </Button>
        }
      </div>
    </div>
  )
}

Index.propTypes = {
  item: PropTypes.object,
  setActiveItem: PropTypes.func,
  setModalShow: PropTypes.func
}

Index.defaultProps = {
  item: {},
  setActiveItem: () => { },
  setModalShow: () => { }
}
